// 封装 axios 

// axios 简单封装
/* function axios({ url, method = "GET", params = {}, data = {} }) {
  // 返回一个promise对象
  return new Promise((resolve, reject) => {

    // 处理metho(转大写)
    method = method.toUpperCase()
    // 处理query参数(拼接到url上) id=1&aaa=ccc
    // 
    //   {
    //     id: 1,
    //     aaa: ccc
    //   }
    // 
    let queryString = "";
    Object.keys(params).forEach(key => {
      queryString += `${key}=${params[key]}&`;
    });
    // 判断queryString有没有值
    if (queryString) {
      // 去除最后的&
      queryString = queryString.substring(0, queryString.length - 1);
      // 接到url上
      url += "?" + queryString;
    }
    console.log(queryString);
    // 1.执行异步ajax请求
    // 创建xhr对象
    const request = new XMLHttpRequest();

    // 打开链接(初始化请求，没有请求)
    request.open(method, url, true);
    // 发送请求
    if (method === "GET") {
      request.setRequestHeader("Content-type","application/x-www-form-urlencoded");
      request.send();
    } else if (method === "POST") {
      request.setRequestHeader(
        "Content-Type",
        "application/json;charset=utf-8"
      ); // 告诉服务器请求体的格式是JSON格式
      request.send(JSON.stringify(data)); // 发送JSON格式的请求体参数
    }

    //绑定状态改变的监听
    request.onreadystatechange = function() {
      // 如果请求没有完成，直接结束
      if (request.readyState !== 4) {
        return;
      }
      // 如果响应状态码在[200,300)之间表示请求成功，否则失败
      const { status, statusText } = request;
      if (status >= 200 && status < 300) {
        // 准备结果数据对象response
        // 将返回的数据格式转换成JSON
        const response = {
          data: JSON.parse(request.response),
          status,
          statusText
        };
        // 2.1如果请求成功了，调用resolve()
        resolve(response);
      } else {
        // 2.2如果请求失败，调用reject()
        reject(new Error("request error status is " + status));
      }
    };
  });
} */

// 引入 axios 网络请求框架
import axios from "axios";

function request(config) {

  // 创建 axios 实例
  const instance = axios.create({
    baseURL: "http://zhongshui.365hy.com/",
    timeout: 5000,  // 返回时间
  });

  // 拦截器
  // 拦截请求
  instance.interceptors.request.use(config => {
    return config;
  })
  // 拦截响应
  instance.interceptors.response.use(res => {
    return res
  }, err => {
    console.log('响应错误')
  })

  // 发送网络请求
  return instance(config)
}

export default request


// WEBPACK FOOTER //
// ./src/network/request.js